/**
 * Traduit récursivement un arbre de menu API / fallback via les ids.
 * Clé : menu.items.<id> (ids avec "/" remplacés par "_")
 */
export function menuKey(id) {
  return `menu.items.${String(id || "").replace(/\//g, "_")}`;
}

const GENERIC_LABELS = {
  Analyse: "menu.analyse",
  Análisis: "menu.analyse",
  Analysis: "menu.analyse",
  Resultat: "menu.resultat",
  Résultat: "menu.resultat",
  Results: "menu.resultat",
  Resultado: "menu.resultat",
};

export function translateMenuTree(items, t) {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    let label = item.label;
    const genericKey = GENERIC_LABELS[item.label];
    if (genericKey) {
      label = t(genericKey, item.label);
    } else if (item.id) {
      const key = menuKey(item.id);
      const translated = t(key, item.label);
      label = translated === key ? item.label : translated;
    }
    const next = { ...item, label };
    if (item.children?.length) {
      next.children = translateMenuTree(item.children, t);
    }
    return next;
  });
}
